import React, { type FC } from 'react';
import { Spinner } from '@printdeal/ui-library';

interface Props {
  loadingMessage: string;
}

export const FallbackSpinnerComponent: FC<Props> = ({
  loadingMessage,
}) => (
  <div className="pd-col-span-full pd-py-56">
    <Spinner
      size="lg"
      screenReaderLabel={loadingMessage}
      className="pd-m-auto"
    />
  </div>
);
